let StringUtils = {
    deleteRuSymbols: function (str: string) {
        /**
         * This method removes "RU" symbols
         * @function
         */
        return str.replace(/[а-яА-Я]/g, '')
    },

    deleteEnSymbols: function (str: string) {
        /**
         * This method removes "EN" symbols
         * @function
         */
        return str.replace(/[a-zA-Z]/g, '')
    },

    isEmptyStr: function (str: any) {
        return !str
    },

    isNotEmptyStr: function (str: any) {
        return !this.isEmptyStr(str)
    }
}

export default StringUtils
